<template>
  <div class="payment-successful-message">
    <div
      class="payment-successful-message__title"
      v-html="successMessage.text"
    ></div>
    {{ successMessage.extra }}
    <img
      alt="doxa"
      class="payment-successful-message__logo"
      src="~/assets/images/doxa_black.svg"
    />
  </div>
</template>

<script setup>
defineProps({
  successMessage: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="postcss" scoped>
.payment-successful-message {
  font-family: var(--title-font-family);
  font-size: 48px;
  line-height: 56px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: 600px;
  text-align: center;
  color: var(--black-color);
  background-image: url('~/assets/images/confetti_bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (min-resolution: 192dpi) {
    background-image: url('~/assets/images/confetti_bg@2x.png');
  }

  &__title {
    margin-bottom: 50px;
  }

  &__logo {
    position: absolute;
    top: auto;
    right: 30px;
    bottom: 24px;
    left: auto;
    fill: var(--black-color);
  }

  @media (--small-vp) {
    font-size: 24px;
    line-height: 30px;
    height: 653px;
    padding: 24px;

    &__title {
      margin-bottom: 32px;
    }

    &__logo {
      right: 16px;
      bottom: 16px;
    }
  }
}
</style>
